export const messageColumns = [
  { column: "serial", label: "#", width: "60" },
  { column: "patient", label: "Patient", sortable: true },
  { column: "phone", label: "Phone", sortable: true },
  { column: "reportType", label: "Report", sortable: true },
  { column: "snedStatus", label: "Status", sortable: true, slot: "status" },
  { column: "time", label: "Time", sortable: true },
  { column: "action", label: "Actions", slot: "action" }
];

export const failedMessageColumns = [
  { column: "patient", label: "Patient", sortable: true },
  { column: "phone", label: "Phone", sortable: true },
  { column: "reportType", label: "Report", sortable: true },
  { column: "failureReason", label: "Reason", slot: "error" },
  { column: "retryCount", label: "Attempts", sortable: true },
  { column: "time", label: "Time", sortable: true },
  { column: "action", label: "Actions", slot: "action" }
];
